import { Message } from '../../conversations/types/Conversation';

const INCOMING_SENDER_TYPES = new Set([
  'companyMember',
  'aiAssistant',
  'system',
  'businessSuite',
]);

export const isVisitorWebWidgetMessage = (message: Message): boolean => {
  if (INCOMING_SENDER_TYPES.has(message.sender.type)) {
    return false;
  }

  if (message.sender.type === 'customer') {
    return true;
  }

  return message.source === 'webchat';
};
